<template>
  <div class="auth-container">
    <div class="auth-background"></div>
    <div class="auth-content">
      <el-card class="auth-card" shadow="always">
        <div class="auth-header">
          <h1 class="auth-title">欢迎栀栀</h1>
          <p class="auth-subtitle">请输入啦</p>
        </div>
        
        <el-form 
          :model="loginForm" 
          :rules="rules" 
          ref="formRef" 
          label-position="top"
          class="auth-form"
        >
          <el-form-item label="用户名" prop="username">
            <el-input 
              v-model="loginForm.username" 
              placeholder="请输入用户名"
              size="large"
              :prefix-icon="User"
            />
          </el-form-item>
          
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              size="large"
              :prefix-icon="Lock"
              show-password
            />
          </el-form-item>
          
          <el-form-item>
            <el-button
              type="primary"
              size="large"
              :loading="loading"
              @click="login"
              class="auth-button"
              round
            >
              登 录
            </el-button>
          </el-form-item>
        </el-form>
        
      </el-card>
      

    </div>
    
  </div>
  <div class="beian-info">
        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=32010202012007" 
           rel="noreferrer" 
           target="_blank"
           class="beian-link">
          <img src="http://lzy.zhizhizuimei.top/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png" alt="备案图标" class="beian-icon">
          苏公网安备32010202012007号
        </a>
        <br>
        <a href="https://beian.miit.gov.cn/#/Integrated/index" 
           rel="noreferrer" 
           target="_blank"
           class="beian-link">
          ICP主体备案号苏ICP备2025179859号
        </a>
      </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { User, Lock } from '@element-plus/icons-vue';
import axios from 'axios';

const loginForm = ref({
  username: '',
  password: '',
});

const rules = {
  username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
};

const loading = ref(false);
const router = useRouter();

const login = async () => {
  loading.value = true;
  try {
    const response = await axios.post('/api/auth/login', {
      username: loginForm.value.username,
      password: loginForm.value.password,
    });
    
    if (response.data.data.success) {
      localStorage.setItem('token', response.data.data.token);
      localStorage.setItem('username', response.data.data.user.username);
      ElMessage.success('登录成功');
      router.push({ name: 'home' });
    } else {
      ElMessage.error(response.data.data.message || '登录失败');
    }
  } catch (error) {
    ElMessage.error(error.response?.data?.message || '登录失败，请稍后再试');
  } finally {
    loading.value = false;
  }
};

const goRegister = () => {
  router.push({ name: 'register' });
};
</script>

<style scoped>
.beian-info {
  margin-top: 20px;
  text-align: center;
  font-size: 12px;
  color: #999;
}

.beian-link {
  display: inline-flex;
  align-items: center;
  color: #999;
  text-decoration: none;
  transition: color 0.3s;
}

.beian-link:hover {
  color: #409eff;
}

.beian-icon {
  width: 16px;
  height: 16px;
  margin-right: 5px;
}


.auth-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.auth-background {
  flex: 1;
  background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
  background-size: cover;
}

.auth-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 480px;
  padding: 40px;
}

.auth-card {
  width: 100%;
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.auth-header {
  text-align: center;
  margin-bottom: 30px;
}

.auth-title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.auth-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.auth-form {
  margin-top: 20px;
}

.auth-button {
  width: 100%;
  height: 48px;
  font-size: 16px;
  margin-top: 10px;
}

.auth-footer {
  text-align: center;
  margin-top: 20px;
}

.auth-link {
  color: #606266;
  font-size: 14px;
}

.auth-link:hover {
  color: #409eff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .auth-container {
    flex-direction: column;
  }
  
  .auth-background {
    display: none;
  }
  
  .auth-content {
    width: 100%;
    padding: 20px;
  }
}
</style>